import type { Environment } from '../../../../environments/environment.interface';

enum RouteName {
  Identity = 'identity',
  User = 'user',
}

// Factory function to get identity URLs
export function getIdentityUrls(appConfig: Environment) {
  const IDENTITY_BASE_URL = `${appConfig.BACKEND}${appConfig.BACKEND_IDENTITY_PORT}/${RouteName.Identity}`;

  return {
    IDENTITY_BASE_URL,
    IDENTITY_USER_ROUTE: `${IDENTITY_BASE_URL}/${RouteName.User}`,
  };
}

export enum UserEndpoints {
  CHANGE_PASSWORD_ENDPOINT = 'change-password',
}
